import { PLAY_EVENT, H5_EXT_EVENT, H5_PLAY_EVENT, ErrorCode, Plugin, H5Player } from '@tencent/thumbplayer-h5';
import { __awaiter, __generator, __assign, __extends } from 'tslib';
import { netTool } from '@tencent/thumbplayer-core';

/* eslint-disable @typescript-eslint/naming-convention */
var WaterMarkCoverClassName = 'thumbplayer-watermark-cover';
var WatermarkPluginName = 'ui-watermark';
var MaxRequestRetry = 3;
var RequestTimeout = 5000;
var WatermarkError;
(function (WatermarkError) {
    WatermarkError["ActionWatermarkRequestFailed"] = "001";
})(WatermarkError || (WatermarkError = {}));

function requestActionWatermark(url, duration) {
    return __awaiter(this, void 0, void 0, function () {
        var err, i, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!url)
                        return [2 /*return*/, Promise.reject(err)];
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < MaxRequestRetry)) return [3 /*break*/, 6];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, netTool.jsonp(url, {
                            timeout: RequestTimeout,
                        })];
                case 3:
                    res = _a.sent();
                    return [2 /*return*/, parseActionWatermark(res, duration)];
                case 4:
                    _a.sent();
                    err = WatermarkError.ActionWatermarkRequestFailed;
                    return [3 /*break*/, 5];
                case 5:
                    i++;
                    return [3 /*break*/, 1];
                case 6: return [2 /*return*/, Promise.reject(err)];
            }
        });
    });
}
/**
 * 动态水印协议 http://tapd.woa.com/qqvideo_prj/markdown_wikis/show/#1210114481001145149
 *
 * 动态水印按组（下发array，每个item为一组）和场景（scenes字段）划分
 * 1. 每组有一个开始时间，同时有一个重复次数，在视频时长内循环播放
 * 2. 每组内按scene划分，每个scene有相对于当前循环的开始时间和结束时间
 *
 * 此函数用于解析动态水印协议，将group和scene信息分离，以水印id为key，保存该水印相对于视频时长的绝对时间schedule
 */
function parseActionWatermark(res, videoDuration) {
    var schedules = {};
    var watermarks = {};
    var start = res.start, watermarkDuration = res.duration, repeat = res.repeat, rw = res.rw;
    // 假设单次循环大于视频时长，循环则最多执行一次；所以这里取ceil
    var actualRepeatTime = repeat === 0 ? Math.ceil(videoDuration / watermarkDuration) : repeat;
    var _loop_1 = function (i) {
        // 计算当前循环的基准起点，scene.in是按这个时间偏移的
        var baseStartTime = start + i * watermarkDuration;
        res.scenes.forEach(function (scene) {
            var wi = scene.wi, startTime = scene.in, endTime = scene.out, startFrom = scene.start, endAt = scene.end;
            wi.forEach(function (watermark) {
                watermarks[watermark.id] = __assign(__assign({}, watermark), { action: true, rw: rw });
                // 首次记录
                if (!schedules[watermark.id])
                    schedules[watermark.id] = [];
                // 部分水印仅在特定循环时展示，为0标识都展示。
                if (i >= startFrom && (i <= endAt || i === 0)) {
                    schedules[watermark.id].push({
                        start: (baseStartTime + startTime) / 1000,
                        end: (baseStartTime + endTime) / 1000,
                    });
                }
            });
        });
    };
    for (var i = 0; i < actualRepeatTime; i++) {
        _loop_1(i);
    }
    return {
        schedules: schedules,
        watermarks: watermarks,
    };
}

var str = "<txpdiv data-role=\"txp-ui-watermark-mod\" class=\"txp-watermark\">\n</txpdiv>";

var Watermark = /** @class */ (function () {
    function Watermark(container, config, showOnInit) {
        if (showOnInit === void 0) { showOnInit = false; }
        var cfg = config.cfg, css = config.css;
        this.el = this.createImageNode(css);
        this.el.onload = cfg.onload;
        this.el.onerror = cfg.onerror;
        this.el.src = cfg.url;
        this.el.dataset.id = "" + cfg.id;
        container.appendChild(this.el);
        if (showOnInit) {
            this.show();
        }
        else {
            this.hide();
        }
    }
    Watermark.prototype.destroy = function () {
        var _a;
        if ((_a = this.el) === null || _a === void 0 ? void 0 : _a.parentNode)
            this.el.remove();
        this.el = null;
    };
    Watermark.prototype.show = function () {
        if (this.el) {
            this.el.style.display = 'block';
        }
    };
    Watermark.prototype.hide = function () {
        if (this.el) {
            this.el.style.display = 'none';
        }
    };
    Watermark.prototype.draw = function (css) {
        var left = css.left, top = css.top, width = css.width, height = css.height, position = css.position, opacity = css.opacity, userSelect = css.userSelect;
        if (this.el) {
            this.el.style.left = left;
            this.el.style.top = top;
            this.el.style.width = width;
            this.el.style.height = height;
            this.el.style.opacity = opacity;
            this.el.style.position = position;
            this.el.style.userSelect = userSelect;
        }
    };
    /**
     * 创建一个新的img节点
     * @param css img节点的css信息
     */
    Watermark.prototype.createImageNode = function (css) {
        var left = css.left, top = css.top, width = css.width, height = css.height, position = css.position, opacity = css.opacity, userSelect = css.userSelect;
        var img = new Image();
        img.style.left = left;
        img.style.top = top;
        img.style.width = width;
        img.style.height = height;
        img.style.position = position;
        img.style.opacity = opacity;
        img.style.zIndex = '1';
        img.style.userSelect = userSelect;
        return img;
    };
    return Watermark;
}());

/**
 * Thumbplayer-h5 水印插件，支持动态/静态水印协议
 *
 * 水印协议文档 http://tapd.oa.com/qqvideo_prj/markdown_wikis/show/#1210114481001145149
 */
var WatermarkPlugin = /** @class */ (function (_super) {
    __extends(WatermarkPlugin, _super);
    function WatermarkPlugin(player, config, extra) {
        var _this = _super.call(this, player, config, extra) || this;
        /** 目前渲染的水印 */
        _this.watermarks = {};
        /** 需要动态显示的水印时间表 */
        _this.timeTable = {};
        /**
         * 播放器resize的回调
         */
        _this.onResize = function () {
            Object.values(_this.watermarks).forEach(function (item) {
                var watermarkNode = item[0], watermarkCfg = item[1];
                var newCss = _this.computeCss(watermarkCfg);
                watermarkNode.draw(newCss);
            });
        };
        /** 计算水印的css信息 */
        _this.computeCss = function (watermark) {
            var x = watermark.x, y = watermark.y, h = watermark.h, w = watermark.w, a = watermark.a, _a = watermark.rw, rw = _a === void 0 ? 0 : _a;
            var _b = _this.player, container = _b.container, videoSize = _b.videoSize;
            var vWidth = videoSize.width, vHeight = videoSize.height;
            if (vWidth <= 0)
                vWidth = container.clientWidth;
            if (vHeight <= 0)
                vHeight = container.clientHeight;
            var base = rw > 0 ? (Math.min(vHeight, vWidth) / rw) : 1;
            var wmX = x * base;
            var wmY = y * base;
            var wmH = h * base;
            var wmW = w * base;
            // 视频相对于容器的缩放比例
            var ratio = Math.min(container.clientWidth / vWidth, container.clientHeight / vHeight);
            // 视频渲染出来的实际大小
            var renderVideoWidth = vWidth * ratio;
            var renderVideoHeight = vHeight * ratio;
            // 视频坐标系的原点（左上角）
            var renderOriginX = Math.max((container.clientWidth - renderVideoWidth) / 2, 0);
            var renderOriginY = Math.max((container.clientHeight - renderVideoHeight) / 2, 0);
            // 水印的渲染大小
            var renderWmWidth = wmW * ratio;
            var renderWmHeight = wmH * ratio;
            // 水印的xy定位
            var renderX = (renderOriginX + renderVideoWidth - renderWmWidth - (wmX * ratio));
            var renderY = (renderOriginY + (wmY * ratio));
            // 测试边界
            var playerDim = { x: renderOriginX, y: renderOriginY, w: renderVideoWidth, h: renderVideoHeight };
            var wmDim = { x: renderX, y: renderY, w: renderWmWidth, h: renderWmHeight };
            var css = {
                left: renderX + "px",
                top: renderY + "px",
                width: renderWmWidth + "px",
                height: renderWmHeight + "px",
                position: 'absolute',
                display: 'block',
                opacity: "" + a / 100,
                userSelect: 'none',
            };
            if (!_this.isInScreen(playerDim, wmDim)) {
                css.display = 'none';
            }
            return css;
        };
        _this.config = __assign(__assign({ 
            // 默认开启防盗水印
            enableProtectionWatermark: true }, (_this.player.config.watermarkConfig || {})), config);
        _this.prepareDom();
        window.addEventListener('resize', _this.onResize);
        player.on(PLAY_EVENT.FULLSCREEN_CHANGE, _this.onResize, -1);
        var defaultText = _this.config.defaultText;
        if (defaultText) {
            _this.watermarkThis(defaultText);
        }
        _this.initMutationObserver();
        _this.setupPlayerEvents();
        _this.listenFakeFullscreen();
        return _this;
    }
    /**
     * 添加一个新的水印
     * @param watermark 水印的参数，包括大小，相对位置，以及图片url
     * @param showOnInit 是否直接显示
     */
    WatermarkPlugin.prototype.add = function (watermark, showOnInit) {
        if (showOnInit === void 0) { showOnInit = false; }
        var url = watermark.url, id = watermark.id;
        if (this.watermarks[id]) {
            // console.warn('相同id的水印已经存在，请检查水印的配置');
            return;
        }
        var css = this.computeCss(watermark);
        var cfg = {
            css: css,
            cfg: {
                id: id,
                url: url,
                onerror: function () {
                    this.remove();
                },
            },
        };
        var newWatermark = new Watermark(this.$watermarkContainer, cfg, showOnInit);
        this.watermarks[id] = [newWatermark, watermark];
        return newWatermark;
    };
    /**
     * 为容器添加一个水印遮罩
     * @param text 水印文字
     * @param styleConfig svg样式配置
     */
    WatermarkPlugin.prototype.watermarkThis = function (text, styleConfig) {
        if (styleConfig === void 0) { styleConfig = {}; }
        this.coverWatermarkParam = null; // 先置空，避免mutation observer检测到元素被移除
        var defaultStyle = {
            stroke: 'black',
            transform: 'translate(20, 120) rotate(-30)',
            fill: 'rgb(222, 222, 222)',
            opacity: 0.3,
            'stroke-opacity': 0.3,
            'stroke-width': 1,
            'font-size': '22',
        };
        var defaultSvgStyle = {
            width: '200px',
            height: '200px',
        };
        var container = this.player.container;
        var allWaterMarkCover = container.querySelectorAll("." + WaterMarkCoverClassName);
        allWaterMarkCover.forEach(function (ele) { return ele.remove(); });
        var watermarkEl = document.createElement('div');
        var watermarkSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        var watermarkText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        var _a = styleConfig.svg, svgStyle = _a === void 0 ? {} : _a, _b = styleConfig.text, textStyle = _b === void 0 ? {} : _b;
        // 设置容器属性
        watermarkEl.classList.add(WaterMarkCoverClassName);
        watermarkEl.style.position = 'absolute';
        watermarkEl.style.width = '100%';
        watermarkEl.style.height = '100%';
        watermarkEl.style.userSelect = 'none';
        watermarkEl.style.zIndex = '1';
        // 设置svg属性
        watermarkSVG.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        var svgConfig = __assign(__assign({}, defaultSvgStyle), svgStyle);
        Object.keys(svgConfig).forEach(function (key) {
            watermarkSVG.setAttribute(key, svgConfig[key]);
        });
        // 设置字体属性
        var config = __assign(__assign({}, defaultStyle), textStyle);
        Object.keys(config).forEach(function (key) {
            watermarkText.setAttribute(key, config[key]);
        });
        watermarkText.textContent = text;
        // 组装
        watermarkSVG.appendChild(watermarkText);
        // 设置背景url
        watermarkEl.style.backgroundImage = "url(\"data:image/svg+xml;utf8," + watermarkSVG.outerHTML.replace(/"/g, '\'') + "\")";
        container.appendChild(watermarkEl);
        this.coverWatermarkParam = [text, styleConfig];
        return watermarkEl;
    };
    /**
     * 移除指定id的水印, 同时移除对应的时间表
     * @param id 需要移除的水印的id
     */
    WatermarkPlugin.prototype.remove = function (id) {
        var _a;
        var target = ((_a = this.watermarks[id]) !== null && _a !== void 0 ? _a : [])[0];
        if (target) {
            target.destroy();
            delete this.watermarks[id];
            delete this.timeTable[id];
        }
    };
    /**
     * 销毁所有的水印，清空缓存
     */
    WatermarkPlugin.prototype.clear = function () {
        Object.values(this.watermarks).forEach(function (_a) {
            var i = _a[0];
            return i.destroy();
        });
        this.watermarks = {};
        this.timeTable = {};
    };
    /**
     * 获取指定id的水印实例
     * @param id 水印的id
     */
    WatermarkPlugin.prototype.get = function (id) {
        return this.watermarks[id];
    };
    /**
     * 设定指定id的水印的显示时间, 水印不存在时跳过
     * @param id 水印的id
     * @param start 开始显示的时间，单位秒
     * @param end 结束显示的时间，单位秒
     */
    WatermarkPlugin.prototype.schedule = function (id, start, end) {
        this.timeTable[id] ? this.timeTable[id].push({ start: start, end: end }) : this.timeTable[id] = [{ start: start, end: end }];
    };
    /**
     * 注销指定id的水印的时间表
     * @param id 需要清空时间表的水印的id
     */
    WatermarkPlugin.prototype.unschedule = function (id) {
        var _a;
        delete this.timeTable[id];
        var wm = ((_a = this.watermarks[id]) !== null && _a !== void 0 ? _a : [])[0];
        wm === null || wm === void 0 ? void 0 : wm.hide();
    };
    /** 销毁插件，移除dom元素 */
    WatermarkPlugin.prototype.destroy = function () {
        var _a, _b;
        window.removeEventListener('resize', this.onResize);
        this.player.off(PLAY_EVENT.FULLSCREEN_CHANGE, this.onResize);
        _super.prototype.destroy.call(this);
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
        if ((_a = this.$watermarkContainer) === null || _a === void 0 ? void 0 : _a.parentNode)
            (_b = this.$watermarkContainer) === null || _b === void 0 ? void 0 : _b.remove();
    };
    WatermarkPlugin.prototype.hookPlaySessionStart = function () {
        this.clear();
    };
    WatermarkPlugin.prototype.hookVideoTimeupdate = function (param) {
        var _this = this;
        var playtime = param.playtime;
        Object.entries(this.timeTable).forEach(function (pair) {
            var key = pair[0], value = pair[1];
            var el = _this.watermarks[key][0];
            if (!el)
                return;
            if (value.some(function (_a) {
                var start = _a.start, _b = _a.end, end = _b === void 0 ? Infinity : _b;
                return playtime > start && playtime < end;
            })) {
                el.show();
            }
            else {
                el.hide();
            }
        });
    };
    WatermarkPlugin.prototype.initMutationObserver = function () {
        var _this = this;
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
        }
        this.mutationObserver = new MutationObserver(function (data) {
            _this.checkIsCoverWatermarkRemoved();
        });
        this.mutationObserver.observe(this.player.container, { childList: true, subtree: true, attributes: true });
    };
    WatermarkPlugin.prototype.checkIsCoverWatermarkRemoved = function () {
        var container = this.player.container;
        if (!this.coverWatermarkParam || !container.offsetParent)
            return;
        var el = container.querySelector("." + WaterMarkCoverClassName);
        if (!(el === null || el === void 0 ? void 0 : el.offsetParent)) {
            this.watermarkThis.apply(this, this.coverWatermarkParam);
        }
    };
    WatermarkPlugin.prototype.setupPlayerEvents = function () {
        var _this = this;
        this.msg.on(H5_EXT_EVENT.GETINFO_OVER, function (_a) {
            var data = _a.data;
            _this.watermarkLoadingDefer = new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                var parseData, watermarkList, supplementaryInfo, contentInfo, protectionWatermark, watermarks, timeTable, res_1;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            parseData = data.parseData;
                            if (!parseData)
                                return [2 /*return*/];
                            watermarkList = parseData.watermarkList, supplementaryInfo = parseData.supplementaryInfo;
                            contentInfo = (supplementaryInfo || {}).contentInfo;
                            protectionWatermark = (contentInfo || {}).protectionWatermark;
                            if (this.config.enableProtectionWatermark && protectionWatermark) {
                                this.watermarkThis(protectionWatermark);
                            }
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, requestActionWatermark((_a = watermarkList) === null || _a === void 0 ? void 0 : _a.action, parseData.duration * 1000)];
                        case 2:
                            res_1 = _b.sent();
                            watermarks = Object.keys(res_1.watermarks).map(function (key) { return res_1.watermarks[key]; });
                            timeTable = res_1.schedules;
                            return [3 /*break*/, 4];
                        case 3:
                            _b.sent();
                            return [3 /*break*/, 4];
                        case 4:
                            // 如果没有没有动态水印，使用静态水印
                            if (!watermarks) {
                                watermarks = parseData.watermarkList.wi;
                            }
                            resolve([watermarks, timeTable]);
                            return [2 /*return*/];
                    }
                });
            }); });
        });
        // 首次加载
        this.player.on(H5_PLAY_EVENT.VIDEO_PLAYING, function (_a) {
            var data = _a.data;
            return __awaiter(_this, void 0, void 0, function () {
                var _b, _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (!data.isFirst)
                                return [2 /*return*/];
                            if (!this.watermarkLoadingDefer) return [3 /*break*/, 2];
                            _c = (_b = this.addPendingData).apply;
                            _d = [this];
                            return [4 /*yield*/, this.watermarkLoadingDefer];
                        case 1:
                            _c.apply(_b, _d.concat([_e.sent()]));
                            _e.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        });
        // // 清晰度变更后重绘水印
        this.player.on(H5_PLAY_EVENT.VIDEO_SETLEVEL_END, function (_a) {
            var data = _a.data;
            return __awaiter(_this, void 0, void 0, function () {
                var _b, _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (data.code !== ErrorCode.SUC)
                                return [2 /*return*/];
                            this.clear();
                            if (!this.watermarkLoadingDefer) return [3 /*break*/, 2];
                            _c = (_b = this.addPendingData).apply;
                            _d = [this];
                            return [4 /*yield*/, this.watermarkLoadingDefer];
                        case 1:
                            _c.apply(_b, _d.concat([_e.sent()]));
                            _e.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        });
    };
    WatermarkPlugin.prototype.addPendingData = function (watermarks, timeTable) {
        var _this = this;
        if (watermarks) {
            watermarks.forEach(function (watermark) { return _this.add(watermark, !watermark.action); });
        }
        if (timeTable) {
            Object.keys(timeTable).forEach(function (key) { return timeTable[key].forEach(function (slot) { return _this.schedule(key, slot.start, slot.end); }); });
        }
        this.watermarkLoadingDefer = null;
    };
    /**
     * 注入水印的dom容器
     */
    WatermarkPlugin.prototype.prepareDom = function () {
        var container = this.player.container;
        container.insertAdjacentHTML('beforeend', str);
        this.$watermarkContainer = container.querySelector('[data-role="txp-ui-watermark-mod"]');
    };
    /**
     * 判断水印的css是否在画面内
     * @param container 容器的坐标信息
     * @param item 水印的坐标信息
     */
    WatermarkPlugin.prototype.isInScreen = function (container, item) {
        var ox = container.x, oy = container.y, ow = container.w, oh = container.h;
        var x = item.x, y = item.y, w = item.w, h = item.h;
        // 左边界左侧
        if (x < ox)
            return false;
        // 上边界上侧
        if (y < oy)
            return false;
        // 右边界右侧
        if (x > ox + ow - w)
            return false;
        // 下边界下侧
        return y <= oy + oh - h;
    };
    WatermarkPlugin.prototype.listenFakeFullscreen = function () {
        var _this = this;
        var ctrlName = 'ctrlbar';
        this.msg.on("pluginsetup:" + ctrlName, function () {
            var ctrl = _this.player.plugins[ctrlName];
            ctrl.on('browserFullscreenChange', _this.onResize);
        });
    };
    /** 插件名 */
    WatermarkPlugin.pluginName = WatermarkPluginName;
    return WatermarkPlugin;
}(Plugin));

H5Player.registerPlugin(WatermarkPlugin.pluginName, WatermarkPlugin);

export { WatermarkPlugin };
